import { gql } from "@apollo/client";

export const authMutation = gql`
  mutation authUser($token: String!) {
    auth(token: $token) {
      id
      name
      context {
        workspaceId
        scenarioId
        originId
      }
    }
  }
`;
